<template>
    <div>
        <login :show="show_modal" :base_api_url="base_api_url" ref="login" v-on:logged-in="loggedIn"></login>

        <div v-if="show_intro">
            <slot name="top-content"></slot>
        </div>

        <div v-if="axios_errored">
            <h1>Sorry there are no resources available at this time. Please come back soon.</h1>
        </div>

        <div v-else
            v-for="(data, $index) in api_data" :key="data.id">

            <div class="relative md:flex md:flex-wrap md:-mx-4">
                <img src="/assets/img/face-art.png" alt="Face art"
                    :class="[{'md:block': $index % 2 === 0}, {'transform -rotate-22 left-0 -mt-20 -ml-32': $index % 4 !== 0}, 'hidden absolute right-0 -mt-2 -mr-24']">

                <div class="md:flex-1 lg:w-1/3 md:px-4 mb-6 md:mb-4">
                    <span class="hidden lg:block mb-4 text-30px">&nbsp;</span>

                    <div :class="[
                            {'bg-co-dark-magenta bg-bubble-violet': data.acf.teaching_resources_colour == 'dark_magenta'},
                            {'bg-strong-red bg-bubble-red': data.acf.teaching_resources_colour == 'red'},
                            {'bg-co-dark-blue bg-bubble-dark-blue': data.acf.teaching_resources_colour == 'dark_blue'},
                            {'bg-co-green bg-bubble-green': data.acf.teaching_resources_colour == 'green'},
                            'flex flex-col justify-center items-center w-full bg-co-light-blue bg-bubble-blue bg-cover lg:bg-contain bg-no-repeat bg-bottom text-center p-6 md:p-8'
                        ]"
                        style="min-height: 330px;">

                        <img v-if="data.acf.teaching_resources_image"
                            :src="data.acf.teaching_resources_image"
                            :alt="stripHtml(data.title.rendered)"
                            :class="{'-mt-24': data.acf.teaching_resources_image == `${base_api_url}/app/uploads/2020/12/co-boy-girl-no-shadow.png`}">

                        <h2 class="mt-2 mb-0 px-2 text-white"
                            v-html="data.title.rendered"></h2>
                    </div>
                </div>
                <div class="lg:w-2/3 md:px-4 mb-6 md:mb-4">
                    <div class="md:flex md:flex-wrap md:-mx-4">
                        <div v-for="(video, index) in data.acf.youtube_embed" :key="index"
                            class="md:w-1/2 md:px-4 mb-10">

                            <h3 class="mt-0 text-black">
                                {{ video.youtube_embed_title ? video.youtube_embed_title : 'Video' }}
                            </h3>

                            <youtube-thumbnail
                                :name="video.youtube_id" :id="video.youtube_id"
                                :square="true"
                                :rounded="true"
                                :thumbnail="video.custom_youtube_embed_thumbnail ? video.custom_youtube_embed_thumbnail.url : ''"
                                v-on:click.native="track(stripHtml(video.youtube_embed_title), 'Video', 'Play')"></youtube-thumbnail>
                            
                            <div class="pt-10 text-center">
                                <a :href="`https://www.youtube.com/watch?v=${video.youtube_id}`"
                                    target="_blank"
                                    :class="[
                                        {'bg-co-dark-magenta border-co-dark-magenta': data.acf.teaching_resources_colour == 'dark_magenta'},
                                        {'bg-co-red border-co-red hover:bg-co-blue hover:border-co-blue': data.acf.teaching_resources_colour == 'red'},
                                        {'bg-co-dark-blue border-co-dark-blue': data.acf.teaching_resources_colour == 'dark_blue'},
                                        {'bg-co-green border-co-green': data.acf.teaching_resources_colour == 'green'},
                                        'btn bg-co-blue mx-auto py-3 px-5 text-lg text-white'
                                    ]">
                                    watch on YouTube
                                </a>
                            </div>
                        </div>

                        <div class="md:w-1/2 md:px-4 mb-6 md:mb-10">
                            <h3 class="mt-0 text-black">Learning Activity</h3>

                            <div class="w-full h-64 flex justify-center items-center bg-co-light-blue group overflow-hidden">
                                <a v-if="data.acf.teaching_resource_activity.teaching_resource_activity_file_upload"
                                    :href="data.acf.teaching_resource_activity.teaching_resource_activity_file_upload.url"
                                    class="block text-center"
                                    v-on:click="track(stripHtml(data.title.rendered), 'Activity')"
                                    download>

                                    <div v-if="data.acf.teaching_resource_activity.teaching_resource_teaser_image"
                                        class="p-6">
                                        <img v-if="data.acf.teaching_resource_activity.teaching_resource_teaser_image"
                                            :src="data.acf.teaching_resource_activity.teaching_resource_teaser_image"
                                            :alt="stripHtml(data.title.rendered)"
                                            class="transform group-hover:scale-110 transition-transform duration-500">
                                    </div>

                                    <div v-else-if="data.acf.teaching_resource_activity.teaching_resource_activity_youtube_embed_id">
                                        <youtube-thumbnail
                                            :name="data.slug"
                                            :id="data.acf.teaching_resource_activity.teaching_resource_activity_youtube_embed_id"
                                            :square="true"
                                            :thumbnail="data.acf.teaching_resource_activity.teaching_resource_activity_custom_youtube_thumbnail ? data.acf.teaching_resource_activity.teaching_resource_activity_custom_youtube_thumbnail.url : ''"
                                            v-on:click.native="track(stripHtml(data.title.rendered), 'Activity Video', 'Play')"></youtube-thumbnail>
                                    </div>
                                </a>

                                <p v-else class="text-white text-2xl">Coming Soon</p>
                            </div>

                            <div
                                class="pt-5 md:pt-10 text-center">

                                <a :href="data.acf.teaching_resource_activity ? data.acf.teaching_resource_activity.teaching_resource_activity_file_upload.url : '#'"
                                    :class="[
                                        {'bg-co-dark-magenta border-co-dark-magenta': data.acf.teaching_resources_colour == 'dark_magenta'},
                                        {'bg-co-red border-co-red hover:bg-co-blue hover:border-co-blue': data.acf.teaching_resources_colour == 'red'},
                                        {'bg-co-dark-blue border-co-dark-blue': data.acf.teaching_resources_colour == 'dark_blue'},
                                        {'bg-co-green border-co-green': data.acf.teaching_resources_colour == 'green'},
                                        'btn bg-co-blue mx-auto py-3 px-5 text-lg text-white'
                                    ]"
                                    v-on:click="track(stripHtml(data.title.rendered), 'Activity')"
                                    download>
                                    download activity
                                </a>
                            </div>
                        </div>

                        <div v-if="data.acf.teaching_resources_image_block"
                            class="md:w-1/2 md:px-4 mb-6 md:mb-10">
                            <h3 class="mt-0 text-black">&nbsp;</h3>

                            <div class="w-full h-64 flex justify-center items-center bg-co-light-blue overflow-hidden">
                                <div class="p-6">
                                    <img v-if="data.acf.teaching_resources_image_block.url"
                                        :src="data.acf.teaching_resources_image_block.url"
                                        :alt="data.title.rendered">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <hr class="mt-8 border-co-light-grey">
        </div>

        <div v-if="show_intro">
            <slot name="bottom-content"></slot>
        </div>
    </div>
</template>

<script>
import Login from './Login.vue'
import YoutubeThumbnail from './YoutubeThumbnail.vue'

export default {
    components: {
        Login,
        YoutubeThumbnail,
    },
    props: {
        base_api_url: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            show_modal: false,
            api_data: false,
            axios_errored: false,
            show_intro: false
        }
    },
    methods: {
        isLoggedIn() {
            const authCookie = this.$cookies.get('auth')
            const codeCookie = this.$cookies.get('code')

            if (authCookie === null || codeCookie === null) {
                return true; // false
            }

            if (!this.$refs.login) {
                return true;
            }

            const authValue = this.$refs.login.cookieValueDecoded(authCookie)

            if (authValue.indexOf(codeCookie) < 0) {
                return true; // false
            }

            this.show_intro = true
            
            return true
        },
        loggedIn() {
            this.loadVideos()

            this.show_intro = true
        },
        loadVideos() {
            axios.get(`${this.base_api_url}/wp-json/wp/v2/videos?categories=3&status=publish&order=asc`)
                .then(response => {
                    this.api_data = response.data
                })
                .catch(error => {
                    this.axios_errored = true
                })
        },
        track(title, type, action = 'Download') {
            if (typeof ga === 'function') {
                ga('send', 'event', 'Teaching Resources', action, `${title} ${type}`)
            }
        },
        stripHtml(html) {
            return html.replace(/(<([^>]+)>)/gi, ' ')
        }
    },
    beforeMount() {
        // Check they have session data, if not, show the modal
        if (!this.isLoggedIn()) {
            this.show_modal = true
            return
        }
    },
    mounted() {
        // Check they have session data, if not, show the modal
        if (!this.isLoggedIn()) {
            return
        }

        this.loadVideos()
    }
}
</script>
